/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2023 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2023-11-27
 *
 * ---------------------------------------------------------------------------
 */

const dev = {
  clientId: 'TCm21HIz70O1MPOS',
  OPServer: 'http://127.0.0.1:3000/auth',
  redirectURL: 'http://127.0.0.1:3000',
  scope: 'openid email profile',
  userInfoEndpoint: '/userinfo',
  oblixIdFieldName: 'oblix_id',
  isAdminFieldName: 'isAdmin',
  isAdminFieldValue: 'Yes',
  oblixIdNameInUserInfo: 'oblix_id',
  isAdminNameInUserInfo: '',
  authServerUrl: 'http://127.0.0.1:9000/auth/', // Used for logout
  logoutUrl: 'http://127.0.0.1:9000/auth/logout?original_url=http://127.0.0.1:3000/logout',
  extra: { prompt: 'consent', access_type: 'offline' }
};

const prod = {

};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  // Add common config values here
  ...config
};
